import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import Featured from '../components/Featured';
import { DataContext } from '../context/DataContext';
import HomeworkQuestions from '../components/common/HomeworkQuestions'
import { animated, useSpring } from "react-spring";
import { toTitleCase } from '../util/titleCase'
import BareboneModal from '../components/common/BareboneModal'

const ViewHomework = () => {
    const dataContext = useContext(DataContext);
    const [showModal, setShowModal] = useState(false);

    const homework = JSON.parse(localStorage.getItem('clickedHomework'));
    const transitionStyles = useSpring({
        to: [
            { opacity: 1, transform: 'translateX(0)' },
        ],
        from: { opacity: 0, transform: 'translateX(80px)' },
        config: { duration: 1000 }
    });

    const Title = () => (
        <div> Alert!! </div>
    )
    
    const Body = () => (
    <div className='text-red-100 mt-4'> An error occured </div>
    )

    return (
        <>
            {showModal && <BareboneModal Title={Title} Body={Body} />}
            <div className='flex mt-8 sm:mt-8 overflow-x-hidden sm:overflow-auto'>
                <animated.div style={transitionStyles} className="w-full sm:w-2/3 sm:ml-3 px-4 mb-4 sm:mb-0">
                    <div className='w-full flex flex-col'>
                        <div className="flex sm:ml-0">
                            <span className="flex items-center py-2 px-3 bg-white rounded-md border border-gray-600 h-10 cursor-pointer">
                                <Link to='homework' className="leading-4 text-xs text-gray-100 mr-3"> homework </Link>
                                <span className="mr-3">
                                    <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.78571 3.62884C6.07143 3.7938 6.07143 4.20619 5.78571 4.37115L0.642857 7.34038C0.357143 7.50534 -3.31824e-08 7.29914 -1.87614e-08 6.96923L2.40817e-07 1.03077C2.55238e-07 0.700852 0.357143 0.494656 0.642857 0.659613L5.78571 3.62884Z" fill="#439ADE" />
                                    </svg>
                                </span>
                                <span className="flex flex-no-wrap text-xs text-blue-100 font-semibold leading-4">
                                    {toTitleCase(homework.subject)}
                                </span>
                            </span>
                        </div>
                        <div className="w-full sm:w-auto my-4">
                            <HomeworkQuestions setShowModal={setShowModal} />
                        </div>
                    </div>
                </animated.div>
                {/* <div className="hidden sm:block w-1/3 mx-4 h-screen">
                    <Featured />
                </div> */}
            </div>
        </>
    )
}

export default ViewHomework;